module.exports = __webpack_public_path__ + "img/no-select-notification.e23b8ba9.svg";